import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300];

interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  perPage: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (size: number) => void;
}

export function Pagination({ page, totalPages, total, perPage, onPageChange, onPerPageChange }: PaginationProps) {
  if (total === 0) return null;

  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  const btnClass = 'p-1.5 rounded-lg border border-[var(--color-border)] hover:bg-[var(--color-surface-hover)] disabled:opacity-30 transition-colors';

  return (
    <div className="flex items-center justify-between text-sm flex-wrap gap-2">
      {/* Left: info */}
      <span className="text-[var(--color-text-muted)] whitespace-nowrap">
        {start}–{end} de {total.toLocaleString()}
      </span>

      {/* Center: page size selector */}
      <div className="flex items-center gap-1.5">
        <span className="text-[var(--color-text-muted)] text-xs">Por página:</span>
        <select
          value={perPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
          className="text-xs rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-text)] px-1.5 py-1 cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {PAGE_SIZE_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      {/* Right: navigation */}
      <div className="flex items-center gap-1">
        <span className="text-[var(--color-text-muted)] mr-1 whitespace-nowrap">
          {page} / {totalPages}
        </span>
        <button onClick={() => onPageChange(1)} disabled={page === 1} className={btnClass} title="Primera">
          <ChevronsLeft size={15} />
        </button>
        <button onClick={() => onPageChange(page - 1)} disabled={page === 1} className={btnClass} title="Anterior">
          <ChevronLeft size={15} />
        </button>
        <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages} className={btnClass} title="Siguiente">
          <ChevronRight size={15} />
        </button>
        <button onClick={() => onPageChange(totalPages)} disabled={page >= totalPages} className={btnClass} title="Última">
          <ChevronsRight size={15} />
        </button>
      </div>
    </div>
  );
}
